module.exports = __webpack_public_path__ + "static/4-b8a4d6beb196e08c0b4ec14ba76a8faa.jpg";